"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var axios_1 = __importDefault(require("axios"));
var classnames_1 = __importDefault(require("classnames"));
var input_dropzone_jsx_1 = __importDefault(require("~/components/forms/inputs/input_dropzone.jsx"));
var input_resizing_dropzone_store_1 = __importDefault(require("~/stores/forms/builder/input_resizing_dropzone_store"));
var dialog_store_1 = __importDefault(require("~/stores/dialog_store"));
var user_profile_modal_1 = __importDefault(require("~/components/users/estimates/requests/messages/user_profile_modal"));
var KeyEnter = 'Enter';
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form(props) {
        var _this = _super.call(this, props) || this;
        _this.inputText = '';
        _this.formRef = react_1.default.createRef();
        _this.isUserProfileModalOpen = false;
        _this.textAreaFocused = false;
        _this.handleChange = function (event) {
            _this.inputText = event.target.value;
        };
        _this.handleSubmit = function (event) {
            event.preventDefault();
            _this.postPhoto().then(function () {
                if (_this.inputText.length > 0 && _this.formRef.current) {
                    _this.formRef.current.submit();
                }
                else {
                    location.reload();
                }
            });
        };
        _this.handleClickQuickInputTextButton = function (event, text) {
            event.preventDefault();
            _this.inputText += text;
            // そのまま submit すると textarea に値が入らないので一回リレンダリングされるをの待つために 10ms 入れる
            setTimeout(function () { return _this.formRef.current && _this.formRef.current.submit(); }, 10);
        };
        _this.handleClickCalendarButton = function (event) {
            event.preventDefault();
            _this.props.onClickCalendarButton();
        };
        _this.handleClickInsertProfileButton = function (event) {
            event.preventDefault();
            _this.isUserProfileModalOpen = true;
        };
        _this.handleCloseUserProfileModal = function () {
            _this.isUserProfileModalOpen = false;
        };
        _this.handleClickConfirmUserProfile = function () {
            _this.props.userProfileStore
                .saveProfile()
                .then(function () {
                _this.inputText += _this.props.userProfileStore.userProfileText;
                _this.isUserProfileModalOpen = false;
            });
        };
        _this.handleFocusTextArea = function () {
            if (!_this.textAreaFocused) {
                _this.textAreaFocused = true;
            }
        };
        _this.handleKeyUpTextArea = function (event) {
            if (event.key === KeyEnter && event.ctrlKey) {
                _this.formRef.current && _this.formRef.current.submit();
            }
        };
        _this.postPhoto = function () {
            var _a = _this.props, photoEndpoint = _a.photoEndpoint, photoName = _a.photoName;
            var data = new FormData();
            var value = _this.dropzoneStore.getValue();
            if (!value) {
                return Promise.resolve();
            }
            data.append(photoName, value);
            return axios_1.default
                .post(photoEndpoint, data)
                .catch(function (error) {
                if (error.response.data.messages) {
                    dialog_store_1.default.showDialogWithCloseButton('画像の保存に失敗しました', error.response.data.messages.join('<br/>'), undefined);
                }
                else {
                    throw JSON.stringify(error.response);
                }
            });
        };
        _this.dropzoneStore = new input_resizing_dropzone_store_1.default();
        return _this;
    }
    Object.defineProperty(Form.prototype, "submitDisabled", {
        get: function () {
            return this.inputText.length === 0 && this.dropzoneStore.getValue() === undefined;
        },
        enumerable: false,
        configurable: true
    });
    Form.prototype.render = function () {
        var _this = this;
        var _a = this.props, action = _a.action, authenticityToken = _a.authenticityToken, bodyName = _a.bodyName, placeholder = _a.placeholder, formDisabled = _a.formDisabled, isSmartPhone = _a.isSmartPhone, showsCalendarButton = _a.showsCalendarButton, quickInputTexts = _a.quickInputTexts;
        var imageSrc = this.dropzoneStore.getValue();
        var selectedFileName = this.dropzoneStore.getFileName();
        return (react_1.default.createElement("div", { className: "usersEstimatesRequestsMessages-Form" },
            react_1.default.createElement(user_profile_modal_1.default, { store: this.props.userProfileStore, isModalOpen: this.isUserProfileModalOpen, onCloseModal: this.handleCloseUserProfileModal, onClickConfirm: this.handleClickConfirmUserProfile }),
            react_1.default.createElement("form", { action: action, method: "POST", ref: this.formRef },
                react_1.default.createElement("input", { type: "hidden", name: "authenticity_token", value: authenticityToken }),
                react_1.default.createElement("div", { className: "usersEstimatesRequestsMessages-Form_FormHeader" },
                    react_1.default.createElement("label", { htmlFor: "request_message_body", className: "usersEstimatesRequestsMessages-Form_BodyLabel" }, "\u30E1\u30C3\u30BB\u30FC\u30B8\u6295\u7A3F\u30D5\u30A9\u30FC\u30E0"),
                    react_1.default.createElement("div", { className: "usersEstimatesRequestsMessages-Form_ActionButtonWrapper" },
                        showsCalendarButton &&
                            react_1.default.createElement("button", { onClick: this.handleClickCalendarButton, className: "sw-Button sw-Button-controlSub usersEstimatesRequestsMessages-Form_ActionButton" },
                                react_1.default.createElement("i", { className: "fa fa-calendar-alt usersEstimatesRequestsMessages-Form_ActionButtonIcon" }),
                                !isSmartPhone &&
                                    react_1.default.createElement("span", { className: "usersEstimatesRequestsMessages-Form_ActionButtonText" }, "\u30AB\u30EC\u30F3\u30C0\u30FC\u3092\u8868\u793A")),
                        react_1.default.createElement("button", { onClick: this.handleClickInsertProfileButton, className: "sw-Button sw-Button-controlSub usersEstimatesRequestsMessages-Form_ActionButton" },
                            react_1.default.createElement("i", { className: "fa fa-clipboard usersEstimatesRequestsMessages-Form_ActionButtonIcon" }),
                            react_1.default.createElement("span", { className: "usersEstimatesRequestsMessages-Form_ActionButtonText" }, isSmartPhone ? '本査定依頼情報' : '本査定依頼情報を入力')))),
                react_1.default.createElement("div", { className: "usersEstimatesRequestsMessages-Form_BodyWrapper" },
                    react_1.default.createElement("textarea", { id: "request_message_body", onChange: this.handleChange, onKeyUp: this.handleKeyUpTextArea, onFocus: this.handleFocusTextArea, name: bodyName, value: this.inputText, placeholder: placeholder, className: (0, classnames_1.default)('usersEstimatesRequestsMessages-Form_Body', { 'usersEstimatesRequestsMessages-Form_Body-expand': this.textAreaFocused }), disabled: formDisabled, required: true }),
                    react_1.default.createElement("div", { className: "usersEstimatesRequestsMessages-Form_QuickInputTextButtonWrapper" }, quickInputTexts.map(function (text) { return react_1.default.createElement("button", { key: text, onClick: function (event) { return _this.handleClickQuickInputTextButton(event, text); }, className: "usersEstimatesRequestsMessages-Form_QuickInputTextButton" }, text); }))),
                react_1.default.createElement("div", { className: "usersEstimatesRequestsMessages-Form_Actions" },
                    imageSrc
                        ? react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("img", { src: imageSrc, alt: selectedFileName || '選択済みの画像', className: "usersEstimatesRequestsMessages-Form_SelectedImage lazyload" }),
                            react_1.default.createElement("button", { className: "sw-Button sw-Button-negative usersEstimatesRequestsMessages-Form_DeleteImageButton", onClick: this.dropzoneStore.resetValue }, "\u53D6\u6D88"))
                        // FIXME: 型推論がうまく行ってくれなくてエラーになるのでいったん諦め(InputResizingDropzoneStoreをTSにすれば多分治る)
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        : react_1.default.createElement(input_dropzone_jsx_1.default, { store: this.dropzoneStore },
                            react_1.default.createElement("div", { className: "usersEstimatesRequestsMessages-Form_PhotoButton" },
                                react_1.default.createElement("i", { className: "fa fa-camera" }),
                                react_1.default.createElement("span", { className: "fs12 ml5" }, "\u753B\u50CF\u3092\u6DFB\u4ED8\u3059\u308B"))),
                    react_1.default.createElement("button", { onClick: this.handleSubmit, className: (0, classnames_1.default)('usersEstimatesRequestsMessages-Form_SubmitButton', { 'usersEstimatesRequestsMessages-Form_SubmitButton-disabled': this.submitDisabled }), disabled: this.submitDisabled }, "\u9001\u4FE1")))));
    };
    var _a, _b;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Form.prototype, "inputText", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_a = typeof input_resizing_dropzone_store_1.default !== "undefined" && input_resizing_dropzone_store_1.default) === "function" ? _a : Object)
    ], Form.prototype, "dropzoneStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_b = typeof react_1.default !== "undefined" && react_1.default.RefObject) === "function" ? _b : Object)
    ], Form.prototype, "formRef", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Form.prototype, "isUserProfileModalOpen", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Form.prototype, "textAreaFocused", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], Form.prototype, "submitDisabled", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function)
    ], Form.prototype, "handleChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function)
    ], Form.prototype, "handleSubmit", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Form.prototype, "handleClickQuickInputTextButton", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Form.prototype, "handleClickCalendarButton", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Form.prototype, "handleClickInsertProfileButton", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Form.prototype, "handleCloseUserProfileModal", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Form.prototype, "handleClickConfirmUserProfile", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Form.prototype, "handleFocusTextArea", void 0);
    Form = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], Form);
    return Form;
}(react_1.default.PureComponent));
exports.default = Form;
